// src/index.js
// ─────────────────────────────────────────────────────────
// Ponto de entrada do React. Não precisa mexer aqui.
// ─────────────────────────────────────────────────────────

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
